import { camelCase, isObject } from 'lodash-es';

export const normalizeObjectKeys = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (isObject(value)) {
        return [camelCase(key), normalizeObjectKeys(value)];
      }

      return [camelCase(key), value];
    }),
  );
};

export const extractPropsFromPromotion = (originalProps) => {
  const { userOrganizationId, show, feature, promotionType, appendAction, appendSelector, ...bannerProps } =
    normalizeObjectKeys(originalProps);
  let appendElement = document.querySelector(appendSelector);
  
  // Create a hidden virtual element if appendSelector element doesn't exist.
  // Then you can move the element into your Vue component and make it visible
  if (!appendElement && appendSelector && show) {
    appendElement = document.createElement('div');
    appendElement.style.display = 'none';
    appendElement.setAttribute('data-promotion-virtual-container', 'true');
    document.body.appendChild(appendElement);
  }
  
  const finalProps = {
    show,
    feature,
    promotionType,
    userOrganizationId,
    append: {
      action: appendAction,
      element: appendElement,
    },
    bannerProps,
  };

  return finalProps;
};
